import { isArray, isNil } from "./types";

export const encodeArrayToURL = (key, array) => {
    return array
        .map((value, index) => {
            return `${key}[${index}]=${value}`;
        })
        .join("&");
};

/**
 * Собирает абсолютный URL из хоста в переменной окружения.
 * Локальные хосты работают по http, остальные — по https.
 * Хост с указанной схемой возвращается как есть.
 */
export const buildAppUrl = (host, path = "") => {
    if (!host) return path || "/";

    const base = /^https?:\/\//.test(host)
        ? host
        : `${/^(?:localhost|127\.)/.test(host) ? "http" : "https"}://${host}`;

    return `${base.replace(/\/$/, "")}${path}`;
};

export const encodeURLWithParams = (url, params) => {
    const encodedParams = [];

    Object.entries(params).forEach(([key, value]) => {
        if (isArray(value)) {
            encodedParams.push(encodeArrayToURL(key, value));
        } else if (!isNil(value)) {
            encodedParams.push(`${key}=${value}`);
        }
    });

    return `${url}?${encodedParams.join("&")}`;
};
